import RentCycle from "../apis/RentCycle";
import { sectorDetails } from '../helpers/Utils';
import serverCall from '../modules/serverCall'


export const changeValue = (marketid, positionid)  => async (
  dispatch,
  getState
) => {  
  await  dispatch({ type: "FETCH_MARKET_SELECTED", payload: marketid })
  await  dispatch({ type: "FETCH_POSITION", payload: positionid })

}

export const setVal = (selectedDefinition, selectedWheelPosition)  => async (
  dispatch,
  getState
) => {

  await   dispatch({ type: "WHEEL_POSITION", payload: {selectedDefinition,selectedWheelPosition} })

}
export const fetchCompareMarket =(compareMarket)   => async (
  dispatch,
  getState
) => {

  try {
    await dispatch(fetchMarketDetails(compareMarket));

  }

  catch (error) {
    dispatch({ type: "SERVER_ERROR_STATE", errorState: true, errorMessage: ''});
  }

}
// This is call from Market Search for Desktop and mobile, we are not updating aything except the marketdetails for desktop
// and for mobile we update the store if searched on home page.
export const changeSearchValue = (latestQuarter,selectedGreatregion, searchval, searchdevice) => async (
  dispatch,
  getState
) => {

   try { 

       
        await dispatch(fetchMarketDetails('FETCH_MARKET_DETAILS', searchval.trim()));

        const basepath = getState().basepath

        const isHomePage = (window.location.pathname  === (basepath === "" ? "/" : basepath))

        if (searchdevice === "mobile" && isHomePage) {


       //   await  dispatch({ type: "FETCH_MARKET_SELECTED", payload: searchval })
          await  dispatch({ type: "FETCH_PERIODS", payload: latestQuarter });
          await  dispatch({ type: "FETCH_MARKETS_INREGION", payload: selectedGreatregion });
          // this is needed for mobile
          await dispatch(fetchMarketsWheel(latestQuarter));    
          await  dispatch({ type: "FETCH_PERIODS_Number", payload: 9 })
  
              let positionList = [getState().marketswheel]; 
              let positionselected = 0
  
              positionList.forEach(function(item) {
                item.forEach(function (x) {
                  if (x.market === searchval && x.period === latestQuarter) 
                  {
                    positionselected = x.position
                  }
                })
            }); 
      
          await   dispatch({ type: "FETCH_POSITION", payload: positionselected })
            let sectorcolor = sectorDetails(getState().positionselected);
          
            //let marketbg = document.getElementById('Market-Info-background');
            let marketbg = document.getElementById('Market-Info');

            if(marketbg)
            {
              marketbg.setAttribute("fill", sectorcolor.sectorColor);
            }

            let positionSector = 'Position-' + getState().positionselected + '-sector-mobile'
            if(positionSector)
            {
                let wheelPosition = document.getElementById(positionSector)
                if(wheelPosition)
                {
                    let event = document.createEvent("SVGEvents");
                    event.initEvent("click",true,false);
                    event.simulated =true;
                    //this is to handle  multiple search falling on same position 
                    wheelPosition.classList.remove('control-active');
                    
                    wheelPosition.dispatchEvent(event);  
                }
            }
            let selectedDefinition = 10
            let selectedWheelPosition = parseInt(positionselected) ;
    
            await  dispatch({ type: "FETCH_MARKET_SELECTED", payload: searchval })    
            await  dispatch({ type: "WHEEL_POSITION", payload: {selectedDefinition, selectedWheelPosition} }) 
        } 

       


 }
 catch (error) {
  dispatch({ type: "SERVER_ERROR_STATE", errorState: true, errorMessage: ''});
}
   
};

export const changeSliderValue = (selectedPeriod) => async (
  dispatch,
  getState
) => {

  const periodList = [getState().periodList];
  let myarray = periodList.toString().split(',');
  let period = (myarray[selectedPeriod -1 ]);

  await dispatch({ type: "FETCH_PERIODS_Number", payload: selectedPeriod })
  await dispatch({ type: "FETCH_PERIODS", payload: period });
  await dispatch(fetchMarketsWheel(period));

};

export const fetchMarketsWheel = (period) => async (dispatch, getState) => {
  let selectedRegion = [getState().greaterRegions];

 if (period === undefined || period === null || period === '')
 {
    period= [getState().activePeriod].toString();
    //Ths is to handle activeperiod on initial load
    if(period === '')
    {
       await dispatch(fetchPeriods());
       period= [getState().activePeriod].toString();
    }
 }

 let globalRegionFlag = null;
 let errCode ='';

 if (selectedRegion[0] === "Global") {
   globalRegionFlag = true;
   selectedRegion = [];
 }

 const americasQuery = {
   greaterRegions: selectedRegion ,
   regions: [],
   markets: [],
   periods: [period],
   isGlobal: globalRegionFlag
 };
 
 try {

    return serverCall({
      method:'POST',
      url:`/search` ,
      data: americasQuery
    })
     .then((response) => {
        dispatch({ type: "FETCH_MARKETSWHEEL", payload: response.data });
        dispatch({ type: "SERVER_ERROR_STATE", errorState: false, errorMessage:'' });
     })
     .catch((error) => {
       if (error.response !== undefined){
         errCode = error.response.status
         dispatch({ type: "SERVER_ERROR_STATE", errorState: true, errorMessage: errCode});
       }
     })
 }
 catch (error) {
   dispatch({ type: "SERVER_ERROR_STATE", errorState: true, errorMessage: errCode});
 }

};

export const fetchPeriods = () => async dispatch => {
  try {
    const response = await RentCycle.get("/Period");

    let array_last_nine;
    array_last_nine = response.data.slice(-5);  //reduced to 5 periods

    if (response.data.length < 5) { //reduced to 5 periods
      array_last_nine.shift();
    }
    
    dispatch({ type: "FETCH_PERIODS_CALL", periodList: array_last_nine });
    dispatch({ type: "FETCH_PERIODS", payload: array_last_nine[4] });
    dispatch({ type: "SERVER_ERROR_STATE", errorState: false, errorMessage: '' });
  }
  catch (error) {
    dispatch({ type: "SERVER_ERROR_STATE", errorState: true, errorMessage: ''});
  }
};

export const fetchGreaterRegions = (greaterRegion) => async (dispatch, getState) => {
  await dispatch({ type: "FETCH_MARKETS_INREGION", payload: greaterRegion });

  let globalRegionFlag = null;
  let greaterRegionValue = [greaterRegion];

  const selectedPeriod = getState().activePeriod;


  if (greaterRegion === "Global") {
    globalRegionFlag = true;
    greaterRegionValue = [];
  }

  const americasQuery = {
    greaterRegions: greaterRegionValue,
    regions: [],
    markets: [],
    periods: [selectedPeriod],
    isGlobal: globalRegionFlag
  };

  let errCode = '';

 try {

      return serverCall({
        method:'POST',
        url:`/search` ,
        data: americasQuery
      })
      .then((response) => {
          dispatch({ type: "FETCH_MARKETSWHEEL", payload: response.data });
          dispatch({ type: "SERVER_ERROR_STATE", errorState: false, errorMessage:'' });
      })
      .catch((error) => {
        if (error.response !== undefined){
          errCode = error.response.status
          dispatch({ type: "SERVER_ERROR_STATE", errorState: true, errorMessage: errCode});
        }
      })
  }
  catch (error) {
    dispatch({ type: "SERVER_ERROR_STATE", errorState: true, errorMessage: errCode});
  }
};


export const fetchMarkets = () => async (dispatch) => {

  let errCode ='';
  try {

    await RentCycle.get("/Markets")
      .then((response) => {
         dispatch({ type: "FETCH_MARKETS", payload: response.data });
         dispatch({ type: "SERVER_ERROR_STATE", errorState: false, errorMessage:'' });
      })
      .catch((error) => {
        if (error.response !== undefined){
          errCode = error.response.status
        }
        if (error.response !== undefined && error.response.status === 504) {
            RentCycle.request(error.config).then((response) => {
            dispatch({ type: "FETCH_MARKETS", payload: response.data });
            dispatch({ type: "SERVER_ERROR_STATE", errorState: false, errorMessage:'' });
          }).catch((error) => {
            dispatch({ type: "SERVER_ERROR_STATE", errorState: true, errorMessage: ''});
          });
        }

      })

  }
  catch (error) {
    dispatch({ type: "SERVER_ERROR_STATE", errorState: true, errorMessage: errCode});
  }
};

export const fetchMarketDetails= (actiontype,market) => async (dispatch, getState) => {
  try {

    let selectedMarket = [market.trim()];;
    let greaterRegion =[];
    let actionType = actiontype ;
    let globalRegionFlag = null;
    let region = [];

    if (market === undefined) 
    {
      selectedMarket= [getState().marketselected.trim()];
    }

    let marketsInfo= getState().markets.filter (l => {
    
      
      return  (l.market.trim().toLowerCase() === (market.trim().toLowerCase()) )
    
    });;
  
   if(marketsInfo.length<=0)
   {
    // as we copy paste detail url, markets info is not available by this time 
      await dispatch(fetchMarkets());
      marketsInfo= getState().markets.filter (l => {
       
            return  (l.market.trim().toLowerCase() === (market.trim().toLowerCase()) )

      });;
   }
   greaterRegion =  [(marketsInfo[0] ? marketsInfo[0].greaterRegion : "Global")];
   
     if (greaterRegion[0] === "Global") {
        globalRegionFlag = true;
        greaterRegion = [];
      }
      else
      {
        region = [(marketsInfo[0] ? marketsInfo[0].region : "")];

      }
 
    const searchQuery = {
      greaterRegions:greaterRegion,
      regions: region,
      markets: selectedMarket,
      periods: [],
      isGlobal: globalRegionFlag
    };
     const response = await RentCycle.post("/search", searchQuery);

   dispatch({type: actionType,  payload : response.data})
   dispatch({ type: "SERVER_ERROR_STATE", errorState: false, errorMessage:'' });

  }
  catch (error) {
   dispatch({ type: "SERVER_ERROR_STATE", errorState: true, errorMessage: ''});
  }
};

export const setAndFetchGreaterRegions = (greaterRegion) => async (dispatch, getState) => {
  await dispatch({ type: "SET_DETAIL_GREATERREGION", payload: greaterRegion });

  let errCode ='';
  try {

      return serverCall({
          method:'GET',
          url: `/greater-region/${greaterRegion}/Markets`,
        })
        .then((response) => {
            dispatch({ type: "FETCH_COMPARE_MARKETS", payload: response.data });
            dispatch({ type: "SERVER_ERROR_STATE", errorState: false, errorMessage:'' });
        })
        .catch((error) => {
          if (error.response !== undefined){
            errCode = error.response.status
            dispatch({ type: "SERVER_ERROR_STATE", errorState: true, errorMessage: errCode});
          }
        })


  }
  catch (error) {
    dispatch({ type: "SERVER_ERROR_STATE", errorState: true, errorMessage: errCode});
  }

}; 
  
  
export const resetCompareMarketsQuarters =()   => async (dispatch) => {
  let actionType='RESET_MARKET_COMPARE_QUARTERS';
  let marketCompareQuarters = [];
  try {
    await dispatch({type: actionType,  payload : marketCompareQuarters});
  }

  catch (error) {
    dispatch({ type: "SERVER_ERROR_STATE", errorState: false, errorMessage:'' });
  }

};



export const setCompareMarket = (market)  => async (
  dispatch
  ) => {  
  await  dispatch({ type: "COMPARE_MARKET_SELECTED", payload: market })
}


export const clearCompareInfo = (clearText, clearArray)  => async (
    dispatch
) => {
    dispatch({ type: "SET_DETAIL_GREATERREGION", payload: clearText })
    dispatch({ type: "FETCH_COMPARE_MARKETS", payload: clearArray })
    dispatch({ type: "FETCH_MARKET_COMPARE_QUARTERS", payload: clearArray })
    dispatch({ type: "COMPARE_MARKET_SELECTED", payload: clearText })
}

export const clearCompareInfoMobile = (clearText, clearArray)  => async (
    dispatch
) => {
    dispatch({ type: "FETCH_COMPARE_MARKETS", payload: clearArray })
    dispatch({ type: "FETCH_MARKET_COMPARE_QUARTERS", payload: clearArray })
    dispatch({ type: "COMPARE_MARKET_SELECTED", payload: clearText })
}

/* export const fectchDetailDataMobile = () => async (dispatch, getState) => {
  try {
// This method is used to load the data for detail view on mobile - No comparison Data

    let selectedMarket;
    let selectedRegion;
    let actionType;
    let globalRegionFlag = null;

   
      selectedMarket= getState().marketselected.trim();
      selectedRegion= [getState().greaterRegions.trim()]; 
      actionType="FETCH_MARKET_QUARTERS"; 
    
      if (selectedRegion[0] === "Global") {
        globalRegionFlag = true;
        selectedRegion = [];
      }
  
     const searchQuery = {
      greaterRegions:selectedRegion,
      regions: [],
      markets: [],
      periods: [],
      isGlobal: globalRegionFlag
    };
  

    const response = await RentCycle.post("/RentCycleData/Search", searchQuery);
    let  marketdetails = response.data.filter(l => {
   
    
     return  (l.market.trim() === (selectedMarket.trim()) )
   
  });

   dispatch({type: actionType,  payload : marketdetails})
   dispatch({ type: "SERVER_ERROR_STATE", errorState: false, errorMessage:'' });
  }
  catch (error) {
   dispatch({ type: "SERVER_ERROR_STATE", errorState: true, errorMessage: ''});

  }
}; */

export const setMarketSelected = (selection) => {
  return { type: 'SET_MARKET_SELECTED', selection }
}

export const setComparisonMarketSelected = (selection) => {
  return { type: 'SET_COMPARISON_MARKET_SELECTED', selection }
}

export const clearMarketDetails = () => {
  return { type: 'CLEAR_MARKET_SELECTED' }
}

export const clearComparisonMarketDetails = () => {
  return { type: 'CLEAR_COMPARISON_MARKET_SELECTED' }
}

export const setBasePath = (basepath)  => async (
  dispatch
  ) => {  
  await  dispatch({ type: "BASE_PATH_NAME", payload: basepath })
}

export const fetchQuarterPeriods = () => async dispatch => {
    try {
        const response = await RentCycle.get("/Period");
        let quarterPeriods = response.data.slice(-9);
        let quarterLookup = {};

        if(!quarterPeriods || quarterPeriods.length === 0) {
            return;
        }

        if(quarterPeriods.length > 0) {
            quarterPeriods = quarterPeriods.map((period, periodIndex) => {
                const translated = period.replace(' ', ', ').replace('Q', 'Quarter ');
                quarterLookup[translated] = periodIndex;
                return translated;
            });
            quarterPeriods = quarterPeriods.reverse();
        }
        dispatch({ type: "QUARTER_PERIODS_FETCH_SUCCESS", payload: quarterPeriods, lookup: quarterLookup });
    }
    catch (error) {
        dispatch({ type: "SERVER_ERROR_STATE", errorState: true, errorMessage: ''});
    }
};

export const updateMarketWheel = (selectedPeriod) => async (
    dispatch,
    getState
) => {

    const periodList = [getState().periodList];
    let periodArray = periodList.toString().split(',');
    let period = (periodArray[selectedPeriod]);

    await dispatch({ type: "FETCH_PERIODS_Number", payload: selectedPeriod });
    await dispatch({ type: "FETCH_PERIODS", payload: period });
    await dispatch(fetchMarketsWheel(period));
};

export const setSelectedQuarter = (selectedQuarterIndex) => {
    return { type: "SET_SELECTED_QUARTER", selectedQuarterIndex }
}

export const setSelectedUnit = (selectedUnit) => {
  return { type: "SET_UNIT_METRIC", unitMetric: selectedUnit }

}
